// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase : {
    apiKey: "AIzaSyAUVfx8-oj_OmkVahIeYLWxbHAm4WoVp_M",
    authDomain: "microsites-78459.firebaseapp.com",
    projectId: "microsites-78459",
    storageBucket: "microsites-78459.appspot.com",
    messagingSenderId: "330105550981",
    appId: "1:330105550981:web:830d0b5285e17cd64e51ec",
    measurementId: "G-8CB7S0K4RT"
  }

};
export const enableLogging = true;
export const baseUrl = 'https://adminmicrosites.azurewebsites.net/api';
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
import 'zone.js/dist/zone-error';  // Included with Angular CLI.

